import * as React from "react"
import { Link } from "gatsby"
import { IconChat, IconChevronRight, IconEmail, IconRing } from "../icons/Icons"
import { StaticImage } from "gatsby-plugin-image"
import Logo from "../../icons/SellUsYourJewelry"
import useMediaQuery from "../../hooks/useMediaQuery"
import TailwindScreens from "../../helpers/tailwind"
import { useState, useCallback, useEffect } from "react"

const Submenu = ({ children, heading, to, className = "md:grid-cols-4", dropdown }) => {
  const [isOpen, setIsOpen] = useState(false)
  const isMd = useMediaQuery(TailwindScreens.md)
  const openMenu = useCallback(
    e => {
      e.preventDefault()
      setIsOpen(true)
    },
    [setIsOpen]
  )
  const closeMenu = useCallback(
    e => {
      e.preventDefault()
      setIsOpen(false)
    },
    [setIsOpen]
  )
  useEffect(() => {
    if (!dropdown || !isOpen) {
      setIsOpen(false)
    }
  }, [dropdown, isOpen, setIsOpen])
  return (
    <div
      className={
        "text-gray-700 w-full border-b-[1px] border-gray-100 indent-10 uppercase " +
        "md:w-auto md:border-0 md:indent-0 md:p-2 group "
      }
    >
      {isMd ? (
        <Link
          to={to}
          className={
            "w-full py-3 md:p-0  block text-current md:hover-underline-animation md:text-center md:text-sm md:text-white md:hover:text-white"
          }
        >
          {heading}
          <IconChevronRight className={"ml-2 md:rotate-90"} />
        </Link>
      ) : (
        <a
          onClick={openMenu}
          href={to}
          className={
            "w-full py-3 hover:tracking-wider hover:text-accentMd duration-300  block text-current md:hover-underline-animation md:text-center md:text-sm md:text-white md:hover:text-white"
          }
        >
          {heading}
          <IconChevronRight className={"ml-2 md:rotate-90"} />
        </a>
      )}
      <div
        className={
          (isOpen
            ? "bg-white text-white min-h-screen fixed z-50 top-16 md:hidden border-t-[1px] border-accentMd flex flex-col w-full "
            : "hidden ") +
          "md:absolute md:left-0 md:w-full md:p-4 md:mt-2 md:animate-fade-in md:gap-2 " +
          "md:duration-150 md:ease-in-out md:group-hover:grid md:hidden md:bg-white " +
          "md:shadow-md md:normal-case " +
          className
        }
      >
        <button
          onClick={closeMenu}
          className="text-left bg-accentMd hover:bg-accent text-xl font-bold indent-10 text-white py-3 md:hidden"
        >
          <IconChevronRight className="rotate-180 translate-y-1 mx-3" />
          {heading}
        </button>
        {children}
      </div>
    </div>
  )
}

const SubmenuLink = ({ children, to, image, className = "" }) => {
  return (
    <Link
      to={to}
      className={
        "w-full py-3 md:p-0 block text-gray-700 hover:text-accentMd hover:tracking-wider border-b-[1px] border-gray-100 indent-10 uppercase duration-300 " +
        "md:w-auto md:p-0 md:border-0 md:indent-0 md:hover:tracking-normal md:normal-case " +
        (className || "md:text-center md:text-accent")
      }
    >
      {image ? <div className={"hidden md:block"}>{image}</div> : ""}
      {children}
    </Link>
  )
}

const MenuLink = ({ children, to }) => {
  return (
    <div
      className={
        "text-gray-700 w-full hover:text-accentMd hover:tracking-wider border-b-[1px] border-gray-100 indent-10 uppercase duration-300 " +
        "md:w-auto md:p-2 md:border-0 md:indent-0 md:hover:tracking-normal "
      }
    >
      <Link
        to={to}
        className={
          "w-full py-3 md:p-0 block text-current md:hover-underline-animation md:text-center md:text-sm md:text-white md:hover:text-white"
        }
      >
        {children}
      </Link>
    </div>
  )
}

const HomeMenu = ({ dropdown, setDropdown }) => {
  return (
    <>
      <div className="fixed top-0 md:static z-50 flex h-16 flex-row items-center w-full justify-between bg-white py-2 px-10 shadow-xl">
        <Link to={"/"} className={"logo "} onClick={() => setDropdown(false)}>
          <Logo className={"w-[236px] p-2"} />
        </Link>
        <div className="hidden justify-end md:block">
          <div className="flex flex-row space-x-10  ">
            <a href={"mailto:sell@grayandsons.com"}>
              <IconEmail />
              &ensp; E-mail
            </a>
            <a href={"tel:+13057706955"}>
              <IconRing />
              &ensp; Call
            </a>
            <Link to={"/chat-suyj/"}>
              <IconChat /> &ensp; Chat
            </Link>
          </div>
        </div>
        <button
          aria-label={"Main Menu"}
          className="relative z-20 inline-block h-8 w-8 p-1 text-accent md:hidden"
          onClick={() => {
            setDropdown(!dropdown)
          }}
        >
          <svg fill="currentColor" viewBox="0 0 20 20" xmlns="https://www.w3.org/2000/svg">
            <path
              fillRule="evenodd"
              d="M3 5a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 10a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1zM3 15a1 1 0 011-1h12a1 1 0 110 2H4a1 1 0 01-1-1z"
              clipRule="evenodd"
            />
          </svg>
        </button>
      </div>
      <nav
        role="navigation"
        className={
          (dropdown ? "" : "hidden") +
          // mobile styles
          // ' absolute top-16 left-0 z-40 w-full bg-black p-6 text-gray-700 shadow-md' +
          // md and up styles
          " md:relative md:z-50 md:top-0 md:flex md:w-auto md:justify-center md:bg-link md:p-0 md:shadow-none"
        }
        itemScope
        itemType="https://schema.org/SiteNavigationElement"
        aria-label={"Main Menu"}
      >
        <div
          className={
            "bg-white text-white min-h-screen fixed z-50 right-0 top-16 border-t-[1px] border-accentMd flex flex-col w-full " +
            "md:relative md:justify-center md:gap-2 md:flex-row lg:gap-4 md:border-0 md:min-h-0 md:bg-link md:top-0 md:right-auto md:w-auto"
          }
        >
          <MenuLink to={"/how-it-works/"}>How It Works</MenuLink>
          <Submenu
            heading={"Brands We Buy"}
            to={"/brands-we-buy/"}
            className={"md:grid-cols-6"}
            dropdown={dropdown}
          >
            <SubmenuLink
              to={"/sell-rolex-near-me/"}
              image={<StaticImage src={"../../images/menu/rolex.jpg"} alt={"Rolex"} />}
            >
              Rolex
            </SubmenuLink>
            <SubmenuLink
              to={"/sell-my-audemars-piguet-watch/"}
              image={
                <StaticImage
                  src={"../../images/menu/audemars-piguet.jpg"}
                  alt={"Audemars Piguet"}
                />
              }
            >
              Audemars Piguet
            </SubmenuLink>
            <SubmenuLink
              to={"/sell-patek-philippe-watch/"}
              image={
                <StaticImage src={"../../images/menu/patek-philippe.jpg"} alt={"Patek Philippe"} />
              }
            >
              Patek Philippe
            </SubmenuLink>
            <SubmenuLink
              to={"/sell-tiffany-and-co-jewelry/"}
              image={
                <StaticImage src={"../../images/menu/tiffany-and-co.jpg"} alt={"Tiffany & Co."} />
              }
            >
              Tiffany & Co.
            </SubmenuLink>
            <SubmenuLink
              to={"/sell-van-cleef-and-arpels-jewelry/"}
              image={
                <StaticImage
                  src={"../../images/menu/van-cleef-and-arpels.jpg"}
                  alt={"Van Cleef & Arpels"}
                />
              }
            >
              Van Cleef & Arpels
            </SubmenuLink>
            <SubmenuLink
              to={"/sell-my-cartier-jewelry/"}
              image={<StaticImage src={"../../images/menu/cartier.jpg"} alt={"Cartier"} />}
            >
              Cartier
            </SubmenuLink>
            <SubmenuLink
              to={"/brands-we-buy/"}
              className={"md:col-span-6 md:pt-6 md:text-center md:text-accent"}
            >
              Check all <span className={"hidden md:inline"}>Watch and Jewelry</span> Brands we buy
            </SubmenuLink>
          </Submenu>
          <Submenu
            to={"/what-are-you-looking-to-sell-2/"}
            heading={"Free Quote"}
            dropdown={dropdown}
          >
            <SubmenuLink
              to={"/watch-quote/"}
              image={<StaticImage src={"../../images/menu/watch-quote.jpg"} alt={"Watch Quote"} />}
            >
              Watch Quote
            </SubmenuLink>
            <SubmenuLink
              to={"/jewelry-quote/"}
              image={
                <StaticImage src={"../../images/menu/jewelry-quote.jpg"} alt={"Jewelry Quote"} />
              }
            >
              Jewelry Quote
            </SubmenuLink>
            <SubmenuLink
              to={"/diamond-quote/"}
              image={
                <StaticImage src={"../../images/menu/diamond-quote.jpg"} alt={"Diamond Quote"} />
              }
            >
              Diamond Quote
            </SubmenuLink>
            <SubmenuLink
              to={"/sterling-silver-quote/"}
              image={
                <StaticImage
                  src={"../../images/menu/sterling-silver-quote.jpg"}
                  alt={"Sterling Silver Quote"}
                />
              }
            >
              Sterling Silver Quote
            </SubmenuLink>
          </Submenu>
          <Submenu
            to={"/"}
            heading={"Areas We Serve"}
            className={"md:grid-cols-3"}
            dropdown={dropdown}
          >
            <SubmenuLink
              to={"/sell-jewelry-watches-surfside/"}
              image={<StaticImage src={"../../images/menu/surfside.jpg"} alt={"Surfside"} />}
            >
              Surfside
            </SubmenuLink>
            <SubmenuLink
              to={"/sell-jewelry-and-watches-in-bay-harbor/"}
              image={
                <StaticImage src={"../../images/menu/bal-harbour.jpg"} alt={"Bay Harbor Islands"} />
              }
            >
              Bay Harbor Islands
            </SubmenuLink>
            <SubmenuLink
              to={"/sell-jewelry-watches-fort-lauderdale/"}
              image={
                <StaticImage src={"../../images/menu/ft-lauderdale.jpg"} alt={"Fort Lauderdale"} />
              }
            >
              Fort Lauderdale (40min drive)
            </SubmenuLink>
            <SubmenuLink
              to={"/sell-silver-bowl-miami-beach/"}
              image={
                <StaticImage
                  src={"../../images/menu/west-palm-beach.jpg"}
                  alt={"West Palm Beach"}
                />
              }
            >
              West Palm Beach
            </SubmenuLink>
            <SubmenuLink
              to={"/miami-jewelry-buyer/"}
              image={<StaticImage src={"../../images/menu/miami.jpg"} alt={"Miami"} />}
            >
              Miami (15min drive)
            </SubmenuLink>
            <SubmenuLink
              to={"/sell-jewelry-aventura/"}
              image={<StaticImage src={"../../images/menu/aventura.jpg"} alt={"Aventura"} />}
            >
              Aventura (20min drive)
            </SubmenuLink>
            <SubmenuLink
              to={"/sell-watches-jewelry-miami-beach/"}
              image={<StaticImage src={"../../images/menu/miami-beach.jpg"} alt={"Miami Beach"} />}
            >
              Miami Beach (10 min drive)
            </SubmenuLink>
            <SubmenuLink
              to={"/sell-luxury-watches-and-jewelry-hollywood/"}
              image={<StaticImage src={"../../images/menu/hollywood.jpg"} alt={"Hollywood"} />}
            >
              Hollywood (20min drive)
            </SubmenuLink>
            <SubmenuLink
              to={"/sell-jewelry-watch-naples/"}
              image={<StaticImage src={"../../images/menu/naples.jpg"} alt={"Naples"} />}
            >
              Naples
            </SubmenuLink>
            <SubmenuLink
              to={"/sell-watch-orlando/"}
              image={<StaticImage src={"../../images/menu/orlando.jpg"} alt={"Orlando"} />}
            >
              Orlando
            </SubmenuLink>
            <SubmenuLink
              to={"/what-are-you-looking-to-sell-2/"}
              image={<StaticImage src={"../../images/menu/world-map.jpg"} alt={"Whole World"} />}
              className="md:order-first"
            >
              <span className={"hidden md:inline"}>Through the Mail or Fedex</span> We serve the
              rest of the world
            </SubmenuLink>
          </Submenu>

          <MenuLink to={"/about-us/"}>About Us</MenuLink>
          <MenuLink to={"/contact-us/"}>Contact Us</MenuLink>
          {/* <MenuLink to={"/shop/"}>SHOP</MenuLink> */}
        </div>
      </nav>
      {/*{dropdown ? (*/}
      {/*  <button*/}
      {/*    className={'fixed top-0 left-0 z-10 h-screen w-screen bg-black opacity-30 md:hidden'}*/}
      {/*    onClick={() => {*/}
      {/*      setDropdown(false);*/}
      {/*    }}*/}
      {/*  >*/}
      {/*    <span className={'sr-only'}>Close menu</span>*/}
      {/*  </button>*/}
      {/*) : (*/}
      {/*  ''*/}
      {/*)}*/}
    </>
  )
}

export default HomeMenu
